import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr.json";
import en from "./locales/en.json";

let stored = "fr";
try {
  const v = typeof localStorage !== "undefined" && localStorage.getItem("neldaari_lang");
  if (v === "en" || v === "fr") stored = v;
  else if (v) { try { localStorage.removeItem("neldaari_lang"); } catch (e) { void e; } }
} catch (e) { void e; }

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
  },
  lng: stored,
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export default i18n;
